<script setup lang="ts">
import CheckoutNavigation from '~/components/checkout/Navigation.vue'
import IconBasic from '~/components/icon/IconBasic.vue'
interface Props {
  disabled?: boolean
  loading?: boolean
  returnRoute?: string
}

withDefaults(defineProps<Props>(), {
  disabled: false,
  loading: false,
})
const route = useRoute()
</script>

<template>
  <header
    class="checkout-main-header"
    :class="{ loading }"
  >
    <nuxt-link
      class="close"
      :disabled="loading"
      :to="returnRoute || `/${route.params.storefront}`"
      data-test="close-checkout-button"
      :aria-label="$t('closeIcon')"
    >
      <IconBasic filename="close" />
    </nuxt-link>

    <template v-if="route.params.view !== 'success'">
      <CheckoutNavigation />
    </template>
  </header>
</template>

<style scoped>
.checkout-main-header {
  flex-shrink: 0;
  padding: 0 1rem;

  @media screen and (min-width: 768px) {
    padding: 0 calc(20% + 1.5rem);
  }
  @media screen and (min-width: 1440px) {
    padding: 0 calc(25% + 1.5rem);
  }
  &.loading button.close {
    opacity: 0.0001;
  }
}

.close {
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  padding: 0 1.6rem 0;
  @media screen and (min-width: 480px) {
    padding: 0 12%;
  }
  @media screen and (min-width: 768px) {
    padding: 0 0.8rem;
  }

  .icon {
    width: 1.5rem;
    height: 1.5rem;
  }
  &:focus-visible {
    outline: 2px solid var(--black);
    outline-offset: 2px;
  }
}

@media (min-width: 960px) {
  :deep(.mobile-only) {
    display: none;
  }
}
</style>
